import type { RouteRecordRaw } from 'vue-router';

export const categoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/category',
    name: 'tradeCategory',
    redirect: '/trade/category/list',
    component: () => import('pages/trade/admin/category/McCategory.vue'),
    meta: {
      title: 'Trade Categories [Folders]',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeCategoryList',
        component: () => import('pages/trade/admin/category/CategoryList.vue'),
        meta: {
          title: 'Trade Categories [Folders] List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeCategoryDetail',
        component: () => import('pages/trade/admin/category/CategoryDetail.vue'),
        meta: {
          title: 'Trade Category [Folder] Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeCategoryNew',
        component: () => import('pages/trade/admin/category/CategoryNew.vue'),
        meta: {
          title: 'New Trade Category [Folder]',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeCategoryExplorer',
        component: () => import('pages/trade/admin/category/CategoryExplorerDtable.vue'),
        meta: {
          title: 'Trade Categories [Folders] Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
